/**
 * @author Andrés Camilo Ferreira Rodríguez
 * @Copyright (c) Infotrack. All rights reserved.
 */
import ITiposMovimientos from 'Infotrack@Modelos/smartStock/tiposMovimientos/entidades/tiposMovimientos';
import { TipoFormulario } from '@infotrack/presentacion-transversales/interfacesComunes';
import {
    manejadorIndicadorCargaGlobal,
    manejadorDialogoGlobal,
} from '@infotrack/presentacion-utilitarios/manejadoresComponentes';
import { useProveedor } from '@infotrack/presentacion-componentes/proveedorEstado';
import React from 'react';
import TiposMovimientosCM from '../controladorModelo/tiposMovimientosCM';
import { acciones, IEstadoTiposMovimientos } from '../reductorTiposMovimientos';
import TiposMovimientosVista from '../vista/tablaTiposMovimientosVista';
import Texto from '@infotrack/presentacion-componentes/texto';

const tiposMovimientosCM = new TiposMovimientosCM();

const TableTiposMovimientosCV: React.FunctionComponent = () => {
    const cargaInicial = React.useRef(true);
    const [tiposMovimientoss, setTiposMovimientoss] = React.useState<ITiposMovimientos[]>([]);
    const [{ recargarTabla }, dispatch] = useProveedor<IEstadoTiposMovimientos>();

    React.useEffect(() => {
        if (recargarTabla || cargaInicial.current) {
            cargarTiposMovimientos();
            if (recargarTabla) {
                dispatch({ type: acciones.RECARGAR_TABLA });
            }
        }
        cargaInicial.current = false;
    });

    const cargarTiposMovimientos = () => {
        manejadorIndicadorCargaGlobal(true);
        tiposMovimientosCM.consultarTiposMovimientos().then((tiposMovimientoss) => {
            setTiposMovimientoss(tiposMovimientoss);
            manejadorIndicadorCargaGlobal(false);
        });
    };
    const manejarFormulario = (tipoFormulario: TipoFormulario, entidadTiposMovimientos?: ITiposMovimientos) => {
        dispatch({ type: acciones.CAMBIAR_ESTADO_FORMULARIO, payload: { entidadTiposMovimientos, tipoFormulario } });
    };

    const confirmarEliminacion = (tiposMovimientos: ITiposMovimientos) => {
        manejadorDialogoGlobal({
            accionCancelar: () => manejadorDialogoGlobal({ estado: false }),
            accionConfirmar: () => eliminarTiposMovimientos(tiposMovimientos),
            estado: true,
            mensaje: <Texto id={'alerta.confirmacionEliminacion'} />,
            mostrarCancelar: true,
            tipoDialogo: 'Advertencia',
            titulo: <Texto id="titulo.advertencia" />,
        });
    };

    const eliminarTiposMovimientos = (tiposMovimientos: ITiposMovimientos) => {
        manejadorIndicadorCargaGlobal(true);
        manejadorDialogoGlobal({ estado: false });
        tiposMovimientosCM.eliminarTiposMovimientos(tiposMovimientos).then(() => {
            manejadorIndicadorCargaGlobal(false);
            dispatch({ type: acciones.RECARGAR_TABLA });
        });
    };

    return (
        <TiposMovimientosVista
            tiposMovimientoss={tiposMovimientoss}
            cargarTiposMovimientos={cargarTiposMovimientos}
            confirmarEliminacion={confirmarEliminacion}
            manejarFormulario={manejarFormulario}
        />
    );
};

export default TableTiposMovimientosCV;
